import { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { useGate, useUnit } from 'effector-react';
import { AuthGate } from '@features/authorization/model';
import { AuthForm } from '@features/authorization/organisms/authForm';
import { Header } from '@features/authorization/organisms/header';
import { $isAuthenticated } from '@features/common';
import { ThemeAdapter } from '@shared/theme/adapter';
import * as Styled from './styled';

interface Props {
  location: {
    state?: {
      from: {
        pathname: string;
      };
    };
  };
}

export const AuthorizationPage: FC<Props> = ({ location }) => {
  useGate(AuthGate);
  const isAuthenticated = useUnit($isAuthenticated);

  if (isAuthenticated) {
    return <Redirect to={location.state ? location.state.from : '/'} />;
  }

  return (
    <ThemeAdapter>
      <Styled.Container>
        <Header />
        <Styled.Content>
          <Styled.Logo alt="Ujin" />
          <AuthForm />
        </Styled.Content>
      </Styled.Container>
    </ThemeAdapter>
  );
};
